export default function filenameFromBlobPath(path) {
  if (!path || typeof path !== 'string') return ''
  const parts = path.split('/').filter(Boolean)
  const last = parts[parts.length - 1] || ''
  try {
    return decodeURIComponent(last)
  } catch (_e) {
    return last
  }
}
